module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image26.fd74bb60.webp";